import React from 'react';
import { Cross, BookOpen, Flame, Megaphone, Fingerprint, HandHeart } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';

const ICONS = [Cross, BookOpen, Flame, Megaphone, Fingerprint, HandHeart];

export default function CoreValues() {
  const { t } = useI18n();
  return (
    <section id="values" data-testid="core-values-section" className="relative py-24 lg:py-32 bg-[#1f3a2a] text-[#f5efe3]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <span className="text-[#d4a63d] text-xs uppercase tracking-wider-xtra font-medium">{t.values.eyebrow}</span>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05]">{t.values.title_1} <span className="italic text-[#d4a63d]">{t.values.title_2}</span></h2>
          <p className="mt-6 text-[#f5efe3]/75 text-lg leading-relaxed">{t.values.sub}</p>
        </div>
        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-px bg-[#f5efe3]/10 rounded-2xl overflow-hidden">
          {t.values.items.map((v, i) => {
            const Icon = ICONS[i];
            return (
              <div key={v.title} data-testid={`core-value-${i}`} className="group bg-[#1f3a2a] p-7 hover:bg-[#2e5340] transition-colors duration-300">
                <Icon size={22} strokeWidth={1.6} className="text-[#d4a63d] group-hover:-translate-y-0.5 transition-transform" />
                <h3 className="font-serif-display text-2xl mt-4">{v.title}</h3>
                <p className="mt-2 text-sm text-[#f5efe3]/70 leading-relaxed">{v.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
